import { ActionIcon, CopyButton, Flex, Paper, Tooltip, UnstyledButton } from '@mantine/core'
import { IconCheck, IconCopy } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'

/**
 * The AI's alternatives for one field, one chip each.
 *
 * Two controls per chip, as in the previous ad editor: the icon copies the text
 * for use elsewhere, the text itself replaces the field's value. The chip
 * matching the current value is shown in bold, so the row also says which of
 * the alternatives is in the ad.
 *
 * Renders nothing when the run produced no alternatives for this field, which
 * is every field before the first generation.
 */
export function SuggestionChips({ options, value, onSelect }) {
  const { t } = useTranslation()
  if (!options || options.length === 0) return null

  return (
    <Flex wrap="wrap" gap={4} mt={4}>
      {options.map((option) => (
        <Paper withBorder radius="md" p={0} key={option}>
          <Flex align="center" gap={4} p={0}>
            <CopyButton value={option} timeout={2000}>
              {({ copied, copy }) => (
                <Tooltip label={copied ? t('editorV2.form.common.copied') : t('editorV2.form.common.copy')} withArrow position="top">
                  <ActionIcon
                    color={copied ? 'teal' : 'gray'}
                    variant="subtle"
                    aria-label={copied ? t('editorV2.form.common.copied') : t('editorV2.form.common.copyText', { text: option })}
                    onClick={copy}
                  >
                    {copied ? <IconCheck size={16} /> : <IconCopy size={16} />}
                  </ActionIcon>
                </Tooltip>
              )}
            </CopyButton>
            <UnstyledButton
              fz="sm"
              mr="xs"
              fw={option === value ? 700 : 400}
              onClick={() => onSelect(option)}
            >
              {option}
            </UnstyledButton>
          </Flex>
        </Paper>
      ))}
    </Flex>
  )
}
